export const VENUE_SORT_DIRECTIONS = Object.freeze({
  asc: 'asc',
  desc: 'desc',
});
